export default __webpack_public_path__ + "static/media/fitfren_logo.25afe415.png";